module.exports = __webpack_public_path__ + "img/emoji_00.3b5918ef.png";